import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { decisionMarkdown } from '../../lib/decisionBrief';

export default function DecisionBrief({ decision, data, onClose }) {
  const markdown = decisionMarkdown(decision, data);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const copy = async () => {
    setError('');
    try { await navigator.clipboard.writeText(markdown); setMessage('Decision brief copied.'); }
    catch { setError('Could not copy. Download the brief or select the text below.'); }
  };
  const download = () => {
    const url = URL.createObjectURL(new Blob([markdown], { type: 'text/markdown;charset=utf-8' }));
    const link = document.createElement('a'); link.href = url;
    link.download = `decision-${String(decision.id).replace(/[^a-z0-9-]/gi, '').slice(0, 80)}.md`;
    link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <Dialog open onOpenChange={open => !open && onClose()}><DialogContent className="v2-dialog" aria-label="Decision brief"><DialogHeader><DialogTitle>Decision brief</DialogTitle></DialogHeader>
    <p>Review the brief and its source links before sharing it with stakeholders.</p>
    <div className="v2-actions"><button className="v2-button" onClick={copy}>Copy brief</button><button className="v2-button secondary" onClick={download}>Download Markdown</button><button className="v2-button secondary" onClick={onClose}>Close brief</button></div>
    {message && <p role="status">{message}</p>}{error && <p className="v2-error" role="alert">{error}</p>}
    <label className="v2-field"><span>Brief preview</span><textarea className="decision-brief-preview" readOnly value={markdown} rows={18}/></label>
  </DialogContent></Dialog>;
}
